/**
 * The screen a mobile path shows, as the key its page transition hangs on.
 *
 * A screen is the first path segment: `/chat` and `/chat/:conversationId` are
 * the same screen, so opening a conversation keeps the chat mounted. A listing
 * is the exception — `/listing/:listingId` is a page of its own pushed over the
 * list, so it gets its own key and animates in.
 */
export function mobileScreenKey(pathname: string): string {
  const [screen = "", item] = pathname.split("/").filter(Boolean);
  if (screen === "listing" && item) return "listing/item";
  return screen || "home";
}
